import type { MetadataCategoryViewsAppState } from '../ducks/pages/admin_metadata_categories/types';

const hasSegmentMetadataViews = (
  metadataCategoryViews: MetadataCategoryViewsAppState,
): boolean => {
  const categoriesMap = metadataCategoryViews.segments;

  return Object.entries(categoriesMap).some(([, category]) =>
    category?.views?.length ? category.views.length > 0 : false,
  );
};

export default hasSegmentMetadataViews;
